import React, { useEffect, useState } from 'react';
import { Box, Typography, Card, Avatar, Rating, CircularProgress } from '@mui/material';
import moment from 'moment';
import 'moment/locale/es';
import { urlImg } from '../../common/helpers';
import { getServiceReviews } from '../../../actions/reviews';

moment.locale('es');

const ReviewCard = ({ review }) => {
  const cliente = review.cliente || {};
  const nombre = cliente.name ? `${cliente.name} ${cliente.apellido || ''}`.trim() : 'Usuario';
  const avatarSrc = cliente.avatar
    ? `${urlImg}/users/${cliente._id}/${cliente.avatar}?v=${cliente.versionAvatar || 0}`
    : null;

  return (
    <Card elevation={0} sx={{ p: 2.5, mb: 2, borderRadius: '12px', backgroundColor: '#FFF', border: '1px solid #F0F0F0', boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.02)' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1.5 }}>
        <Box sx={{ display: 'flex', gap: 1.5 }}>
          <Avatar src={avatarSrc} sx={{ width: 44, height: 44, bgcolor: '#0E2465', fontSize: '1rem' }}>
            {!avatarSrc && nombre.charAt(0)}
          </Avatar>
          <Box>
            <Typography variant="subtitle2" fontWeight="bold" color="#0E2465">{nombre}</Typography>
            <Typography variant="caption" color="#737791">
              hace {moment(review.createdAt).fromNow(true)}
            </Typography>
          </Box>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <Rating value={review.rating} readOnly size="small" sx={{ color: '#0E2465' }} />
          <Typography variant="subtitle2" fontWeight="bold" color="#0E2465">{review.rating}</Typography>
        </Box>
      </Box>
      {review.comentario && (
        <Typography variant="body2" color="#737791" sx={{ mt: 1, lineHeight: 1.6 }}>
          {review.comentario}
        </Typography>
      )}
    </Card>
  );
};

const ServiceReviews = ({ servicioId, nombreProveedor }) => {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!servicioId) return;
    setLoading(true);
    getServiceReviews(servicioId).then((data) => {
      setReviews(data || []);
      setLoading(false);
    });
  }, [servicioId]);

  const promedio = reviews.length > 0
    ? (reviews.reduce((acc, r) => acc + r.rating, 0) / reviews.length).toFixed(1)
    : null;

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', mb: 2 }}>
        <Box>
          <Typography variant="h5" fontWeight="bold" color="#0E2465">
            Comentarios destacados
          </Typography>
          <Typography variant="body2" color="#737791">
            {reviews.length > 0
              ? `${reviews.length} opinión${reviews.length !== 1 ? 'es' : ''} sobre ${nombreProveedor || 'este servicio'}`
              : `Comentarios sobre ${nombreProveedor || 'este servicio'}`}
          </Typography>
        </Box>
        {promedio && (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <Typography variant="h6" color="#FFB800">★</Typography>
            <Typography variant="h6" fontWeight="bold" color="#0E2465">{promedio}</Typography>
          </Box>
        )}
      </Box>

      {loading ? (
        <Box sx={{ textAlign: 'center', py: 3 }}>
          <CircularProgress size={28} sx={{ color: '#7495f8' }} />
        </Box>
      ) : reviews.length === 0 ? (
        <Box sx={{ bgcolor: '#F8FAFC', borderRadius: '12px', p: 3, textAlign: 'center' }}>
          <Typography variant="body2" color="#737791">
            Aún no hay comentarios para este servicio.
          </Typography>
        </Box>
      ) : (
        reviews.map((review) => <ReviewCard key={review._id} review={review} />)
      )}
    </Box>
  );
};

export default ServiceReviews;
